import * as React from 'react';
import { MediaQuery, Button } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { usePaymentMethodLabelsMap } from '../../hooks/use-payment-method-labels-map.js';
import { PaypalActionButton } from '../../modules/ExpressPaymentMethods/Paypal/PaypalActionButton/PaypalActionButton.js';
import { ApplePayButton } from '../../modules/ExpressPaymentMethods/ApplePay/ApplePayButton.js';
import { usePaymentsUIContext } from '../../context/PaymentsUI/context.js';
import { PaymentMethod } from '../../models/cart-payment-methods/cart-payment-methods.js';

const PaymentForm = ({ paymentMethod , form , onHandlePaymentAction  })=>{
    const { getLabel , hasLabel  } = useIntl();
    const paymentMethodLabelsMap = usePaymentMethodLabelsMap();
    const breakPoint = MediaQuery.useBreakpoint();
    const { isProcessingOrder  } = usePaymentsUIContext();
    const [enableWaitText, setEnableWaitText] = React.useState(false);
    React.useEffect(()=>{
        if (isProcessingOrder) {
            const timeoutId = setTimeout(()=>{
                setEnableWaitText(true);
            }, 3000);
            return ()=>clearTimeout(timeoutId)
            ;
        } else {
            setEnableWaitText(false);
        }
    }, [
        isProcessingOrder
    ]);
    const actionButton = React.useMemo(()=>{
        switch(paymentMethod){
            case PaymentMethod.APPLE_PAY:
                return /*#__PURE__*/ React.createElement(ApplePayButton, {
                    type: "regular-checkout",
                    onClick: onHandlePaymentAction,
                    disabled: isProcessingOrder
                });
            case PaymentMethod.PAYPAL:
                return /*#__PURE__*/ React.createElement(PaypalActionButton, {
                    onClick: onHandlePaymentAction,
                    disabled: isProcessingOrder
                });
            default:
                return /*#__PURE__*/ React.createElement(Button, {
                    color: "primary",
                    size: breakPoint === MediaQuery.BreakpointName.TABLET_LANDSCAPE ? 'small' : undefined,
                    caption: `${getLabel(`checkout.action.pay.continueWith`)} ${paymentMethodLabelsMap[paymentMethod]}`,
                    "data-t": `button-next-payment`,
                    disabled: isProcessingOrder,
                    onClick: onHandlePaymentAction,
                    isLoading: isProcessingOrder
                });
        }
    }, [
        breakPoint,
        getLabel,
        isProcessingOrder,
        onHandlePaymentAction,
        paymentMethod,
        paymentMethodLabelsMap, 
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: "payment-form-container"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "payment-form-container__form"
    }, form && form), actionButton, hasLabel(`checkout.${paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.toLowerCase()}.instruction`) && /*#__PURE__*/ React.createElement(Text, {
        className: "payment-form-container__instruction"
    }, getLabel(`checkout.${paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.toLowerCase()}.instruction`)), enableWaitText && /*#__PURE__*/ React.createElement(Text, {
        className: "payment-form-container__instruction"
    }, getLabel(`checkout.payment.wait.instruction`)));
};

export { PaymentForm };
//# sourceMappingURL=PaymentForm.js.map
